export const GENIUS_ROUTES = Object.freeze({
  HOME: "/home",
  SCHOOL_LOGIN: "/school-login",
  SCHOOL_REGISTER: "/school-register",
  OLYMPIAD: "/olympiad",
  OLYMPIAD_SCORE: "/olympiad/score",
  OLYMPIAD_MATH: "/olympiad/math",
  OLYMPIAD_HOTS: "/olympiad/hots",
  TESTIMONIALS: "/testimonials",
  HOW_IT_WORKS: "/how-it-works",
  ABOUT: "/about"
});

export const ROUTES = Object.freeze({
  HOME: "/home",
  PROFILE: "/profile",
  STUDENT: "/login",
  OTPLOGIN: "/login-OTP",
  SCHOOL_LOGIN: "/log-in",
  STUDENT_CREATE_ACCOUNT: "/student-create-account",
  SCHOOL_CREATE_ACCOUNT: "/school-create-account",
  // EXPLORE: "/explore",
  REQUEST_CODE: "/requestcode",
  PAGE_NOT_FOUND: "/page-not-found",
  FORGOT_PASSWORD: "/forgot-password",
  // FORGOT_PASSWORD_VERIFY_OTP: "/forgot-password/verify-otp",
  // FORGOT_PASSWORD_RESET_PASSWORD: "/forgot-password/reset-password",
  TANDC: "/terms-and-conditions",
  PANDP: "/privacy-and-policy",
  SCHOOL_ONBOARDING: "/school/onboarding",
  STUDENT_ONBOARDING: "/student/onboarding",
  DASHBOARD: "/dashboard",
  EXAMPAGE: "/exam-page",
  REPORTS: "/reports",
  IDL: "/idl",
  CAREER_COUNSELING: "/career",
  CAREER_COUNSELING_Page: "/career-page",
  REDIRECTION: "/redirection",
  CAREER_COUNSELINGP_REPORTS: "/career_reports"
});
